import dayjs from 'dayjs';

export const transformDate = (date: string) => dayjs(date).format('DD/MM/YYYY');

export const transformAmount = (amount: number) => {
  const transformedAmount = `${amount.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} €`;
  return transformedAmount;
};

export const transformMonthToString = (month: number) => {
  if (month < 10) {
    return `0${month}`;
  }
  return month.toString();
};

export const getMonthDays = (month: number, year: number) => {
  const lastMonthDays = new Date(year, month, 0);
  return lastMonthDays.getDate();
};

export const checkMobileSettlementType = (text: string) => {
  const textElements = text.split(' ');
  const transformedText: string[] = [];
  textElements.map((element) => {
    if (element.length > 5) {
      transformedText.push(`${element.slice(0, 2)}.`);
    } else {
      transformedText.push(element);
    }
  });
  return transformedText.join(' ');
};
